import styled from 'styled-components';

import {
  getGridBase,
  getThemeColor,
  getThemeTransition,
  media,
} from '@utils/styled';

import Hr from 'app/common/components/Hr';
import Button, { BUTTON_VARIANTS } from '@common/components/Button';
import { FormControl } from '@common/components/forms';
import Typography from '@common/components/Typography';

export const FormRow = styled.div`
  ${getGridBase(8)}
`;

export const FormColumn = styled.div`
  grid-column: span 8;

  ${media.from800up`
    grid-column: span 4;
  `}
`;

export const FormHr = styled(Hr)`
  opacity: ${({ isLastStep }) => (isLastStep ? 0 : 1)};
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'section', 3)};
  margin-bottom: ${({ isLastStep }) => (isLastStep ? 0 : 3)}rem;
`;

export const FormFooter = styled.div``;

export const SubmitButton = styled(Button).attrs({
  type: 'submit',
})``;

export const ToggleButton = styled(Button).attrs({
  type: 'button',
  variant: BUTTON_VARIANTS.LEVEL_1_GREEN,
})``;

export const SuccessMessage = styled(Typography).attrs({
  variant: 'body1',
})`
  color: ${getThemeColor('hue.green')};
`;

export const FilesSection = styled.div`
  overflow: hidden;
  max-height: 0;
  transition: ${getThemeTransition('max-height', 'slow', 'easeIn')};

  &.transition-enter {
    overflow: hidden;
    max-height: 0;
  }

  &.transition-enter-active {
    overflow: hidden;
    max-height: 45rem;
  }

  &.transition-enter-done {
    overflow: visible;
    max-height: none;
  }

  &.transition-exit {
    overflow: hidden;
    max-height: 90vh;
  }

  &.transition-exit-done,
  &.transition-exit-active {
    overflow: hidden;
    max-height: 0;
  }
`;

export const SectionTitle = styled(Typography).attrs({
  customAs: 'h2',
  variant: 'h4',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'section', 3)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 5)};
`;

export const SectionDescription = styled(Typography).attrs({
  customAs: 'h3',
  variant: 'paragraph1',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'equal', 7)};
`;

export const SectionDisclaimer = styled(Typography).attrs({
  customAs: 'p',
  variant: 'body2',
})`
  color: ${getThemeColor('bluegrey.60')};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 3)};
`;

export const AcknowledgeFormControl = styled(FormControl)`
  overflow: hidden;
  max-height: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 8)};
  transition: ${getThemeTransition('all', 'default', 'easeIn')};

  &.transition-enter {
    max-height: 0;
    border-top-color: transparent;
  }

  &.transition-enter-active,
  &.transition-exit {
    max-height: 100px;
    border-top-color: ${getThemeColor('bluegrey.90')};
  }

  &.transition-enter-done {
    max-height: none;
    border-top-color: ${getThemeColor('bluegrey.90')};
  }

  &.transition-exit-done,
  &.transition-exit-active {
    max-height: 0;
    border-top-color: transparent;
  }
`;
